<template>
  <div class="vform position-relative" :style="styles.pageColor">
    <shop-header :store-id="currentStoreDoc.ID" />
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row mx-4 justify-content-center">
      <div class="col-lg-9 pb-4">
        <div class="container mt-4 pt-4">
          <navigate-user-back />
          <div class="text-center mt-4 pt-4">
            <div>{{ $t("message.loyaltyStamps") }}</div>
            <div v-if="dbuser">
              {{
                parseInt(dbuser.RewardPoints ? dbuser.RewardPoints : 0)
                  | formatNumber
              }}
            </div>
          </div>
          <div class="col-12 text-center" v-if="loyaltyQr">
            <img :src="this.loyaltyQr" style="height: 35vh" alt="" />
          </div>
          <hr />
          <div class="row">
            <div class="col-6 text-success text-center">
              <div>{{ $t("message.ptsEarned") }}</div>
              <div v-if="dbuser">
                +
                {{
                  parseInt(
                    dbuser.EarnedRewardPoints ? dbuser.EarnedRewardPoints : 0
                  ) | formatNumber
                }}
              </div>
            </div>
            <div class="col-6 text-red text-center">
              <div>{{ $t("message.ptsSpent") }}</div>
              <div v-if="dbuser">
                -
                {{
                  parseInt(
                    dbuser.SpentRewardPoints ? dbuser.SpentRewardPoints : 0
                  ) | formatNumber
                }}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div
          v-if="getFirstValidRedemptionRule"
          class="container mb-4 mt-4 justify-content-center"
        >
          <div class="row justify-content-center mb-4">
            {{ getLoyalityMessage }}
          </div>
          <template v-if="showStampCircle">
            <div width="300" class="row justify-content-center">
              <canvas id="circleContainer"></canvas>
              <div :style="desktopStyles.CommonColorTxt" class="inner-shape">
                <i class="fa fa-heart"></i>
              </div>
            </div>
            <div
              class="row justify-content-center mb-0"
              style="margin-top: 4px; margin-left: -25px"
            >
              {{
                dbuser.RewardPoints
                  ? dbuser.RewardPoints > getFirstValidRedemptionRule.Point
                    ? getFirstValidRedemptionRule.Point
                    : dbuser.RewardPoints
                  : 0
              }}/{{ getFirstValidRedemptionRule.Point }}
            </div>
          </template>
          <hr />
        </div>
        <div
          class="row align-items-center justify-content-center mt-2 text-center"
        >
          <div class="col-12">
            <AppleWallet
              :user-id="userId"
              v-if="isIos"
              :store-id="storeId"
              style="margin: 10px auto; width: 170px"
            />
            <GooglWallet
              @update-status="(u) => updateStatus(u)"
              style="margin: 10px auto; width: 175px"
              v-if="!isIos"
              :user-id="userId"
              :store-id="storeId"
            />
          </div>
        </div>
        <div class="container mt-5 pt-4">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items ml-5">
              <div class="order-item-details col-sm-7">
                <div>{{ $t("message.orderNo") }}.</div>
                <div>
                  {{ order.OrderNumber ? "#" : "" }}{{ order.OrderNumber }}
                </div>
              </div>
              <div class="col-sm-4 text-right mr-5">
                <div class="color-gray fdate" v-html="getCreateDate(order)" />
                <div class="order-item-cost padding-5-left">
                  <span
                    >&nbsp;({{
                      (order.TotalExcludingTax + order.TotalTax)
                        | formatMoney(currencySign)
                    }})</span
                  >
                  <span class="text-red" v-if="order && order.RedeemPoints > 0"
                    >&nbsp;-{{ order.RedeemPoints | formatNumber }}
                    {{ $t("message.stamps") }}</span
                  >
                  <span
                    class="text-success"
                    v-if="order && order.RewardPoints > 0"
                    >&nbsp;+{{ order.RewardPoints | formatNumber }}
                    {{ $t("message.stamps") }}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <!-- <div v-if="pageOrders.length == 0">
            <message :message="getNoOrderAvailable" />
          </div> -->
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import shared from "../../sharedscripts/user/Loyalty.js";
import { mapGetters } from "vuex";
import { interpolate } from "../../api/helpers/stringHelper.js";
import shopHeader from "../../components/shop/partials/shopheader";
import navigateUserBack from "./partials/navigateUserBack";
import QRCode from "qrcode";
import GooglWallet from "./partials/googleWallet.vue";
import AppleWallet from "./partials/appleWallet.vue";
export default {
  components: {
    Pagination,
    shopHeader,
    navigateUserBack,
    GooglWallet,
    AppleWallet,
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev",
        },
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false,
      loyaltyQr: null,
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "getFirstValidRedemptionRule", "styles"]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    getLoyalityMessage() {
      return interpolate(
        this.$t("message.collectGetFree"),
        this.getFirstValidRedemptionRule.Point,
        this.getFirstValidRedemptionRule.Name
      );
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    },
    viewConfig(newValue) {
      if (newValue) {
        this.drawCircle(this.desktopStyles.alertInfoBackGround.background);
      }
    },
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  async mounted() {
    this.setStoreLoaded();
    if (this.showStampCircle) {
      this.drawCircle(this.desktopStyles.alertInfoBackGround.background);
    }
    try {
      const customerMemberCode = this.dbuser
        ? `@${this.dbuser.CustomerMemberCode}`
        : "";
      this.loyaltyQr = await QRCode.toDataURL(customerMemberCode);
    } catch (e) {
      console.error({ e });
    }
    this.updateUserPoints();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
<style module="scss">
iframe {
  top: 0 !important;
}
#dom-container {
  display: flex;
}
</style>
